export class DatetimeDeviceData {
    UtcSeconds: number;
	Offset: number;
	Tz: string;
}
